var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sidePages),function(item){return _c(item.name,{key:item.id,tag:"component",attrs:{"assigned-id":item.id,"params":item.params}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }